// In-memory mirror of the Redux auth session, synced by the store subscription.
let authToken = null;
let authUser = null;

const clearLegacyAuthStorageKeys = () => {
    try {
        localStorage.removeItem("pbx_auth_user");
        localStorage.removeItem("pbx_auth_token");
    } catch {
        // Ignore storage access failures (private mode, blocked storage, etc.).
    }
};

export const setAuthSession = ({ token, user } = {}) => {
    authToken = token || null;
    authUser = user || null;
    clearLegacyAuthStorageKeys();
};

export const clearAuthSession = () => {
    authToken = null;
    authUser = null;
    clearLegacyAuthStorageKeys();
};

export const getAuthToken = () => authToken;

export const getAuthUser = () => authUser;
